import { Box, IconButton, Typography } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { memo } from "react"

import { TABLE_HEADERS } from "../constants"
import { type ProductConditions } from "../types"
import { createColumns } from "../utils"

import { ColumnContent } from "./ColumnContent"

import type { Product } from "@/graphql/codegen/graphql"

interface ProductConditionsTableProps {
  productDetails: ProductConditions
  onEdit: (productDetails: Product) => void
  isPastProductVersion: boolean
}

const ProductConditionsTable: FC<ProductConditionsTableProps> = ({ productDetails, onEdit, isPastProductVersion }) => {
  const columns = createColumns(productDetails)

  return (
    <Box className='mt-2 grid grid-cols-5 overflow-hidden border border-gray-100' data-testid='product-conditions-grid'>
      {TABLE_HEADERS.map(({ label }, index) => (
        <Box
          key={label}
          className={`flex items-center bg-gray-100 p-4 ${index !== 0 ? "border-l border-gray-100" : ""}`}
        >
          <Typography variant='subtitle2' className='font-medium text-gray-700'>
            {label}
          </Typography>
        </Box>
      ))}

      {columns.map(({ content, testId, label }, index) => (
        <Box
          key={testId}
          className={`flex items-center p-4 ${index !== 0 ? "border-l border-gray-100" : ""} border-t border-gray-100`}
          data-testid={testId}
        >
          <ColumnContent content={content}>{label}</ColumnContent>
        </Box>
      ))}

      <Box className='flex items-center justify-end border-l border-t border-gray-100 p-4' data-testid='actions'>
        {!isPastProductVersion && (
          <IconButton
            color='primary'
            aria-label='edit product conditions'
            onClick={() => onEdit(productDetails as Product)}
          >
            <EditOutlined />
          </IconButton>
        )}
      </Box>
    </Box>
  )
}

export default memo(ProductConditionsTable)
